import axios from 'axios';
import { userRoutes } from './RoutesApi';
import { hasCourseAccess } from './premiumCourseAccess';

export async function premiumCourseDestination(permissions: string[]) {
  if (permissions.includes('Admin')) return '/cursos-premium';
  const { data } = await axios.get(`${process.env.REACT_APP_API_URL}${userRoutes.STATUS_PAYMENT}`);
  return hasCourseAccess(data) ? '/cursos-premium' : '/pagamentos';
}
